var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('ik-data-table',{attrs:{"entity-name":"BannerCarouselSettings","model":_vm.model,"use-select":false,"icon":"mdi-developer-board"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }